import script from "./LedesSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./LedesSettings.vue?vue&type=script&setup=true&lang=js"

import "./LedesSettings.vue?vue&type=style&index=0&id=70e180c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e180c0"]])

export default __exports__